import { AxiosInstance } from 'axios'
import {
    ProjectTemplate,
    ProjectTemplateCreate,
    ProjectTemplateUpdate,
    ListProjectTemplatesParams,
    PaginatedProjectTemplateResponse,
    ProjectTemplateImportResponse,
} from './template.type'

export class ProjectTemplateApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get all project templates with pagination
     */
    async list(params?: ListProjectTemplatesParams): Promise<PaginatedProjectTemplateResponse> {
        const response = await this.client.get<PaginatedProjectTemplateResponse>('/project-templates', {
            params,
        })
        return response.data
    }

    /**
     * Get a single project template by ID
     */
    async findOne(id: string): Promise<ProjectTemplate> {
        const response = await this.client.get<ProjectTemplate>(`/project-templates/${id}`)
        return response.data
    }

    /**
     * Create a new project template
     */
    async create(payload: ProjectTemplateCreate): Promise<ProjectTemplate> {
        const response = await this.client.post<ProjectTemplate>('/project-templates', payload)
        return response.data
    }

    /**
     * Update a project template
     * Note: If structure is changed, a new version will be created
     */
    async update(id: string, payload: ProjectTemplateUpdate): Promise<ProjectTemplate> {
        const response = await this.client.put<ProjectTemplate>(`/project-templates/${id}`, payload)
        return response.data
    }

    /**
     * Delete a project template (soft delete)
     */
    async delete(id: string): Promise<void> {
        await this.client.delete(`/project-templates/${id}`)
    }

    /**
     * Bulk delete project templates (soft delete)
     */
    async bulkDelete(ids: string[]): Promise<void> {
        await this.client.delete('/project-templates', { data: { ids } })
    }

    /**
     * Import project template from file
     */
    async import(file: File): Promise<ProjectTemplateImportResponse> {
        const formData = new FormData()
        formData.append('file', file)
        const response = await this.client.post<ProjectTemplateImportResponse>('/project-templates/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        })
        return response.data
    }
}
